import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Box, Button } from "@material-ui/core";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import TextField from '@mui/material/TextField';
import Checkbox from "@material-ui/core/Checkbox";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useDispatch } from "react-redux";
import FormControlLabel from '@mui/material/FormControlLabel';
import { getCookie } from "../../services/Cookies";
import { Stack } from "@mui/material";
import { LOADING } from "../../action";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#ddd",
        fontWeight: "bold",
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles({
    tableLayout: {
        boxShadow: "0 0 0 0 #fff !important",
    },
    table: {
        minWidth: 650,
    },
    boxBorder: {
        borderTopLeftRadius: 6,
        borderTopRightRadius: 6,
    },
    justifyContentBetween: {
        justifyContent: "space-between!important",
    },
    overflowHidden: {
        overflow: "hidden",
        height: "20px",
    },
    arrowIcons: {
        fontSize: "46px",
        marginTop: "-12px",
    },
    btnStyle2: {
        borderRadius: "8px",
        border: "2px solid #ff4717",
        boxShadow: "2px 2px 4px 2px #dadada",
        color: "#ffffff",
        background: "#ff4717 !important",
        textTransform: "capitalize",
        padding: "4px 22px",
        marginRight: "8px"
    },
    btnShow: {
        background: "#ff4717",
        color: "white",
        position: "relative",
        left: "0px",
        padding: '7px 20px'
    },
    btnShow1: {
        background: "#ff4717",
        color: "white",
        position: "relative",
        left: "20px",
        padding: '7px 20px',
    },
    btnShow2: {
        background: "#ff4717",
        color: "white",
        position: "relative",
        left: "4px",
        padding: '7px 20px',
    },
    textto: {
        position: "relative",
        left: "20px",
    },
    textcc: {
        position: "relative",
        left: "100px",

    },
});

function AlertContact(props) {

    const history = useHistory();
    const classes = useStyles();
    const [customerBox, setCustomerBox] = React.useState(true);
    const [contractDetails, setContractDetails] = React.useState([]);
    const [toemail, setToEmail] = React.useState("");
    const [ccemail, setCcEmail] = React.useState("");
    const [checked, setChecked] = React.useState(false);
    const { vesselkey } = props;
    let shipParameters = { "to": "", "cc": "", "enablenotifications": false, "prealert": false, "postalert": false }
    const [alertContactValue, setAlertContactValue] = React.useState(shipParameters);
    const dispatch = useDispatch();

    const handleChange = (event) => {
        setToEmail(event.target.value);
        setAlertContactValue({ ...alertContactValue, to: (event.target.value) })
    };

    const handleChange1 = (event) => {
        setCcEmail(event.target.value);
        setAlertContactValue({ ...alertContactValue, cc: (event.target.value) })
    }
    const isValidEmail = (email) => {
        return /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/.test(email);
    }
    const handleSave = async () => {
        debugger
        if (isValidEmail(toemail)) {
            if (alertContactValue.prealert == true || alertContactValue.postalert == true) {
                const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Scheduler/Ship/${vesselkey}`;
                dispatch({ type: LOADING, payload: true });
                await postRequest(url, alertContactValue)
                    .then((res) => {
                        dispatch({ type: LOADING, payload: false });
                        if (res.status == 200) {
                            //console.log("response", res.data)
                            ToastSuccess("Inserted successfully");
                        } else {
                            ToastSuccess("Unsucessfull");
                        }
                    })
                    .catch((error) => {
                        dispatch({ type: LOADING, payload: false });
                        //console.log(error);
                    });
            } else {
                ToastError("Either Select PreAlert or PostAlert");
            }
        }
        else if (!isValidEmail(toemail) && !isValidEmail(ccemail)) {
            ToastError("Both To and Cc Email is not Valid");
        }
        else if (!isValidEmail(toemail)) {
            ToastError("To Email is Not Valid");
        }
        else if (!isValidEmail(ccemail)) {
            ToastError("Cc Email is not Valid");
        }
    }


    const getvesselKeyEmailData = async () => {
        ////
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Scheduler/Ship/${vesselkey}`;
        dispatch({ type: LOADING, payload: true });
        await getRequest(url)
            .then((res) => {
                dispatch({ type: LOADING, payload: false });
                if (res.status == 200) {
                    if (res.data.length !== 0) {
                        setToEmail(res.data[0].t_O);
                        setCcEmail(res.data[0].cc);
                        setAlertContactValue({ ...alertContactValue, to: res.data[0].t_O, cc: res.data[0].cc, enablenotifications: res.data[0].enableNotification, prealert: res.data[0].prealert, postalert: res.data[0].postAlert })
                    } else {
                        setToEmail("");
                        setCcEmail("");
                        setAlertContactValue({ ...alertContactValue, to: "", cc: "", enablenotifications: false, prealert: false, postalert: false })
                    }
                } else {
                    ToastSuccess("Unsucessfull");
                }

            })
            .catch((error) => {
                dispatch({ type: LOADING, payload: false });
                ////console.log(error);

            });

    }
    useEffect(() => {
        ////
        if (vesselkey !== undefined && vesselkey !== null && vesselkey !== "") {
            getvesselKeyEmailData();
        }
    }, [vesselkey]);
    return (
        <div>
            <Box component="div" bgcolor="#fff" boxShadow={1} borderRadius={6}>
                <Box
                    component="div"
                    bgcolor="#1A1A31"
                    py={1.0}
                    px={3}
                    fontWeight={600}
                    fontSize={15}
                    color="#fff"
                    className={classes.boxBorder}
                >
                    <Box display="flex" className={classes.justifyContentBetween}>
                        <Box component="span" fontSize="18px">
                            Scheduler Alert Contact
                        </Box>
                        <Box
                            component="span"
                            width="0.03"
                            className={classes.overflowHidden}
                        >
                            <Box display={customerBox ? "inline" : "none"} component="span">
                                <ArrowDropDownIcon
                                    className={classes.arrowIcons}
                                    onClick={() => {
                                        setCustomerBox(!customerBox);
                                    }}
                                />
                            </Box>

                            <Box display={!customerBox ? "inline" : "none"} component="span">
                                <ArrowDropUpIcon
                                    className={classes.arrowIcons}
                                    onClick={() => {
                                        setCustomerBox(!customerBox);
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>

                <Box component="div" display={customerBox ? "block" : "none"}>
                    <Box pt={2} pl={3} pr={2} pb={2}>
                        <Grid container spacing={2}>
                            <Grid item xs="6">

                                <p> To :
                                    <TextField
                                        sx={{ marginLeft: "10px", width: '35ch' }}
                                        size="small"
                                        required
                                        variant="standard"
                                        label="Email"
                                        name="toEmail"
                                        value={alertContactValue?.to}
                                        //placeholder="ex:abc@gmail.com"
                                        onChange={handleChange}
                                        InputProps={{
                                            readOnly: getCookie("userRole") == "ClientAdmin" || getCookie("userRole") == "VPS Admin" || (getCookie("userRole") == "ClientUser" && getCookie("type") == "Client Admin") ? false : true
                                        }}

                                    /></p>



                            </Grid>

                            <Grid item xs="6">
                                <p>Cc :
                                    <TextField
                                        sx={{ marginLeft: "10px", width: '35ch' }}
                                        size="small"
                                        //margin="dense"
                                        required
                                        variant="standard"
                                        label="Email"
                                        name="ccEmail"
                                        value={alertContactValue?.cc}
                                        //placeholder="ex:abc@gmail.com"
                                        onChange={handleChange1}
                                        InputProps={{
                                            readOnly: getCookie("userRole") == "ClientAdmin" || getCookie("userRole") == "VPS Admin" || (getCookie("userRole") == "ClientUser" && getCookie("type") == "Client Admin") ? false : true
                                        }}
                                    /></p>
                            </Grid>

                        </Grid>
                        <Grid container spacing={1}>

                            <Box pb={2}>
                                <FormControlLabel disabled={getCookie("userRole") == "ClientUser" && getCookie("type") !== "Client Admin" ? true : false} label="Enable Notification"
                                    control={<Checkbox checked={alertContactValue.enablenotifications} onChange={(newvalue) => {
                                        if (newvalue.target.checked === true) {
                                            setAlertContactValue({ ...alertContactValue, enablenotifications: newvalue.target.checked })
                                        }
                                        else {
                                            setAlertContactValue({ ...alertContactValue, enablenotifications: false, prealert: false, postalert: false })
                                        }
                                    }} />}
                                />
                            </Box>


                        </Grid>

                        <Grid container spacing={1}>

                            <Box pb={2}>
                                {/* {alertContactValue.enablenotifications==true?
                               <> */}
                                <FormControlLabel disabled={getCookie("userRole") == "ClientUser" && getCookie("type") !== "Client Admin" || alertContactValue.enablenotifications == false ? true : false} label="PreAlert"
                                    control={<Checkbox checked={alertContactValue.prealert} onChange={(newvalue) => setAlertContactValue({ ...alertContactValue, prealert: newvalue.target.checked })} />}
                                />
                                <FormControlLabel disabled={getCookie("userRole") == "ClientUser" && getCookie("type") !== "Client Admin" || alertContactValue.enablenotifications == false ? true : false} label="PostAlert"
                                    control={<Checkbox checked={alertContactValue.postalert} onChange={(newvalue) => setAlertContactValue({ ...alertContactValue, postalert: newvalue.target.checked })} />}
                                />
                                 {/* </>
                                :""}  */}
                            </Box>

                        </Grid>
                        <Grid>
                            {getCookie("userRole") == "ClientAdmin" || getCookie("userRole") == "VPS Admin" || (getCookie("userRole") == "ClientUser" && getCookie("type") == "Client Admin") ?
                                <Button variant="outlined" className={classes.btnStyle2} onClick={handleSave}>Save</Button> : ""}
                        </Grid>
                    </Box>

                </Box>

            </Box>
        </div>
    );
}

export default AlertContact;
